<template>
  <select-rounded
    :custom-label="customLabel"
    v-bind="$attrs"
    @input="handleInput"
  ></select-rounded>
</template>

<script>
import selectRounded from './simple-inputs/select-rounded.vue'

export default {
  components: { selectRounded },
  name: 'customSelectSort',
  methods: {
    customLabel({ label }) {
      return label
    },
    handleInput(value) {
      this.$emit('input', value)
    }
  }
}
</script>